import { compose, includes, prop } from 'ramda';
import { createSelector } from 'reselect';

import { codelists } from 'constants/codelists';
import contacts from 'features/views/contacts';
import { getIdsByPropValue } from 'utils';
import { getCodelistByName } from 'utils/codelists';

import { NAME } from './constants';

const getRoot = prop(NAME);

export const getSelectedContactId = compose(prop('selectedContactId'), getRoot);
export const getSort = compose(prop('sort'), getRoot);

export const getSelectedContact = createSelector(
	contacts.selectors.getAllContacts,
	getSelectedContactId,
	(contacts, selectedId) => contacts[selectedId],
);

export const getIsContactInSuccessfullState = createSelector(
	getCodelistByName(codelists.solutionState),
	(state, solutionStateId) => solutionStateId,
	(solutionStates, solutionStateId) => {
		const successStateIds = getIdsByPropValue(solutionStates, 'stateType', 'SUCCESSFUL');
		const final = includes(solutionStateId, successStateIds);
		return final;
	},
);
